import * as React from 'react';
import Regra from '../components/classes/Regra';
import Usuario from '../components/classes/Usuario';
import UsuarioAuth from '../components/classes/UsuarioAuth';

class UsuarioHelper {
    usuario : Usuario;
    token : String;
    usuarioAuth :UsuarioAuth;
    constructor() {
       //    console.log(localStorage.getItem("UsuarioCache"));
           this.usuario = JSON.parse(String(localStorage.getItem("UsuarioCache")));

      //     console.log(String(localStorage.getItem("Token")));
           this.token = String(localStorage.getItem("Token"));

       //    console.log(String(localStorage.getItem("AutUser")));
           this.usuarioAuth = JSON.parse(String(localStorage.getItem("AutUser")));           
        }
    
    ContemEssaRegra(regra : string) : boolean {
        var _regra = this.usuario.regras.find(r=>r.descricao.toUpperCase() === regra.toUpperCase());
        if (_regra === undefined)
           return false;
        else
           return true;
     }

    GetFullName(): string {        
        return this.usuario.nome;
    }

    GetEmail() : string {        
        return this.usuario.email;
    }

    GetRegras(): Regra[] {        
        return this.usuario.regras;
    }

    GetToken(): String {
        return this.token;
    }
}

export default UsuarioHelper;